import { FieldError } from "@design-system/shadcn";
import React from "react";

import {
  type FieldValidationError,
  useFieldContext,
} from "../core/form-contexts";
import { getFieldErrorId } from "../core/get-field-error-id";

type FormFieldErrorProps = Omit<
  React.ComponentProps<typeof FieldError>,
  "errors" | "children" | "id"
>;

function FormFieldError(props: FormFieldErrorProps) {
  const field = useFieldContext<unknown>();

  if (!field) {
    throw new Error("FormFieldError must be used within form.AppField");
  }

  const errors = field.state.meta.errors as FieldValidationError[];

  if (errors.length === 0) {
    return null;
  }

  return (
    <FieldError errors={errors} {...props} id={getFieldErrorId(field.name)} />
  );
}

export { FormFieldError };
export type { FormFieldErrorProps };
